var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOther28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99972 14.8574C11.7868 14.8574 14.8569 11.7873 14.8569 8.00021C14.8569 4.21311 11.7868 1.14307 7.99972 1.14307C4.21263 1.14307 1.14258 4.21311 1.14258 8.00021C1.14258 11.7873 4.21263 14.8574 7.99972 14.8574ZM11.1426 9.14307C11.7738 9.14307 12.2854 8.63139 12.2854 8.00021C12.2854 7.36903 11.7738 6.85735 11.1426 6.85735C10.5114 6.85735 9.99972 7.36903 9.99972 8.00021C9.99972 8.63139 10.5114 9.14307 11.1426 9.14307ZM9.14258 8.00021C9.14258 8.63139 8.6309 9.14307 7.99972 9.14307C7.36854 9.14307 6.85686 8.63139 6.85686 8.00021C6.85686 7.36903 7.36854 6.85735 7.99972 6.85735C8.6309 6.85735 9.14258 7.36903 9.14258 8.00021ZM4.85686 9.14307C5.48805 9.14307 5.99972 8.63139 5.99972 8.00021C5.99972 7.36903 5.48805 6.85735 4.85686 6.85735C4.22568 6.85735 3.71401 7.36903 3.71401 8.00021C3.71401 8.63139 4.22568 9.14307 4.85686 9.14307Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther28);
export default __webpack_public_path__ + "static/media/other_28.f7a415ed.svg";
export { ForwardRef as ReactComponent };